import { render } from "./ProfilePrivacy.vue?vue&type=template&id=17d74192&scoped=true"
import script from "./ProfilePrivacy.vue?vue&type=script&lang=js"
export * from "./ProfilePrivacy.vue?vue&type=script&lang=js"

import "./ProfilePrivacy.vue?vue&type=style&index=0&id=17d74192&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d74192"]])

export default __exports__